import BlogCard from "./BlogCardHome";
import BlogImg1 from "../../assets/bpo-example.png";
import BlogImg2 from "../../assets/eaf-example.png";
import BlogImg3 from "../../assets/web-example.png";
import { blogs } from "../../data/Blog.data";
import { Link } from "react-router-dom";

export default function BlogsSection() {
  return (
    <section className="relative overflow-hidden bg-white py-20">
      {/* Background shape */}
       <div className="pointer-events-none absolute -top-32 -right-48 h-[520px] w-[520px] rounded-full bg-gray-100" />

      <div className="relative z-10 mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="mx-auto max-w-2xl text-center">
          <Link to="/blogs" className="text-3xl font-bold text-gray-900">
            Latest Blogs
          </Link>
          <p className="mt-4 text-gray-600">
            Insights, trends, and expert perspectives from our technology team.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogs.slice(0,3).map((blog) => (
            <BlogCard key={blog.slug} {...blog} />
          ))}
        </div>
      </div>
    </section>
  );
}
